import React, { useState, useRef } from 'react';
import moment from 'moment';
import { IconButton } from '@mui/material';
import { isString, isNumber } from 'lodash';

import { datePickerFormat, getMomentByUtc, LLLFormat } from '../../services/ValidationRules';
import TextField from '../TextField/TextField';
import { CalendarIcon } from './RenderDatePickerFilter';
import { DatePicker } from '../DateTimePickers/DateTimePickers';

const getPresenterDateObj = (value, errorText, isUtc) => {
  const momentByUtc = getMomentByUtc(isUtc);
  let selectedDate = momentByUtc();
  let selectedDateText = '';

  if (value) {
    let data;

    if (isString(value)) {
      data = momentByUtc(value, LLLFormat, true);
    } else if (isNumber(value)) {
      data = momentByUtc(value);
    }
    if (data.isValid()) {
      selectedDateText = data.format(datePickerFormat);
      selectedDate = errorText ? momentByUtc() : data;
    } else {
      selectedDateText = value;
    }
  }

  return { selectedDate, selectedDateText };
};

function RenderDatepicker(props) {
  const [opened, setOpened] = useState(false);

  const inputRef = useRef(null);

  const handleChangeDatePicker = (date) => {
    const formattedLocalDate = moment(date).format(datePickerFormat);
    const momentByUtc = getMomentByUtc(props.isUtc);
    const ts = momentByUtc(formattedLocalDate, datePickerFormat, true).valueOf();

    props.input.onChange(ts);
  };

  const handleDateInputChange = (event) => {
    const text = event.target.value;
    const momentByUtc = getMomentByUtc(props.isUtc);
    const date = momentByUtc(text, datePickerFormat, true);

    if (date.isValid()) {
      const ts = date.valueOf();

      props.input.onChange(ts);
    } else {
      props.input.onChange(text);
    }
  };

  const openDatePicker = () => {
    setOpened(true);
  };

  const closeDatePicker = () => {
    setOpened(false);
  };

  const {
    meta: { error },
    input: { value, name },
    label,
    required,
    floatingLabelText,
    disabled,
    readOnly,
    className,
    fullWidth,
    isUtc = false,
  } = props;

  const errorText = error || '';
  const formattedLabel = floatingLabelText || label || '';
  const labelText = required ? (
    <span>
      {formattedLabel}
      <span className="required-asterisk">*</span>
    </span>
  ) : (
    formattedLabel
  );
  const { selectedDate, selectedDateText } = getPresenterDateObj(value, errorText, isUtc);
  const iconStyle = readOnly ? { display: 'none' } : {};
  const wrapperClass = `date-picker-container ${className || ''}`;

  return (
    <div className={wrapperClass} data-field-name={`${name}`}>
      <TextField
        id={formattedLabel}
        placeholder={datePickerFormat}
        value={selectedDateText}
        error={!!errorText}
        helperText={errorText}
        fullWidth={fullWidth}
        label={labelText}
        onChange={handleDateInputChange}
        disabled={disabled || readOnly}
        inputRef={inputRef}
      />

      <IconButton size="large" className="calendarIcon" style={iconStyle} onClick={openDatePicker}>
        <CalendarIcon width={20} height={20} />
      </IconButton>

      <div className="hidden-datePicker">
        <DatePicker
          value={selectedDate}
          open={opened}
          onAccept={handleChangeDatePicker}
          onClose={closeDatePicker}
          format={datePickerFormat}
          anchorEl={inputRef.current}
          isMobile
          hideClearBtn
        />
      </div>
    </div>
  );
}

export default RenderDatepicker;
